<template>
    <div class="uploader-wrapper">
        <toast-container :toastConfig="toastConfig" />
        <div class="uploader-container">
            <Login v-if="!store__loginState.isLoggedIn" />
            <Dashboard v-else />
        </div>
    </div>
</template>

<script>

import { mapState, mapMutations } from 'vuex';
import Login from './components/Login.vue';
import Dashboard from './components/Dashboard.vue';

export default {
    name: 'App',
    components: {
        Login,
        Dashboard
    },
    computed: {
        ...mapState({
            store__loginState: 'loginState',
            store__isLoading: 'isLoading',
            store__toast: 'toast'
        }),
        toastConfig() {
            return {
                positionClass: 'vot-bottom-right'
            };
        }
    },
    async created() {
        const API_URL = document.location.href;
        this.$bus.$on('reAuthenticate', () => {
            this.store__loginState.userId = null;
            this.store__loginState.isLoggedIn = false;
        });

        if (this.$route.query.error !== undefined) {
            this.store__loginState.isPermissionDisabled = true;
            this.$router.replace({});
        } else {
            try {
                const response = await this.$http.get(`${API_URL}api/user/getInfo`);

                if (response) {
                    if (response.data && response.data.user) {
                        this.store__loginState.userId = response.data.user;
                        this.store__loginState.isLoggedIn = true;
                    }
                } else if (response.status !== 401) {
                    this.store__loginState.isPermissionDisabled = true;
                }
            } catch (e) {
                console.warn(e);
            }
        }
    },
    methods: {
        ...mapMutations({
            store__setToast: 'setToast'
        }),
        clearToast() {
            this.store__setToast({
                message: null,
                state: 'success'
            });
        }
    }
};
</script>

<style lang="scss">
    html, body, .uploader-wrapper, .uploader-container {
        height: 100%;
        margin: 0;
    }

    .slds-dropdown-trigger {
        display: block;
    }

    .inline-block {
        display: inline-block;
    }
</style>

<style lang="scss" scoped>
    .uploader-container {
        display: flex;
        flex-direction: column;
    }

    /deep/ .slds-button {
        display: flex;
        align-items: center;
        width: auto;

        .ma-icon {
            font-size: 15px;
            width: 15px;
            line-height: 1;
            height: 16px;
            margin: 0 0.25rem;
        }
    }

    /deep/ .ma-icon {
        &.ma-icon-small {
            font-size: .75rem;
        }

        &.ma-icon-medium {
            font-size: 1.25rem;
        }

        &.ma-icon-large {
            font-size: 1.5rem;
        }

        &.ma-icon-xlarge {
            font-size: 3rem;
        }
    }

    /deep/ .toast-container .toast {
        box-shadow: none;
        padding: 0.75rem 1rem 0.75rem 1.5rem;
        width: 520px;

        .toaster-icon {
            width: 1.5rem;
            height: 1.5rem;
            background-image: none;

            &::before {
                font-size: 1.5rem;
                font-family: "ma-icons-2" !important;
                font-style: normal !important;
                font-weight: normal !important;
                font-variant: normal !important;
                text-transform: none !important;
                speak: none;
                line-height: 1;
                -webkit-font-smoothing: antialiased;
            }

            &.vot-icon-error::before {
                content: "\75";
            }

            &.vot-icon-success::before {
                content: "\e18f";
            }

            &.vot-icon-info::before {
                content: "\e08b";
            }

            &.vot-icon-wait::before {
                content: "\e044";
            }

            &.vot-icon-warning::before {
                content: "\e1b8";
            }
        }

        .toast-close-button .toast-close-button {
            width: 1.5rem;
            height: 1.5rem;
            right: auto;
            top: auto;
            overflow: hidden;
            opacity: 1;
            text-shadow: none;

            &:hover {
                color: #fff;
            }

            &::before {
                content: "\34";
                font-size: 1.5rem;
                font-family: "ma-icons-2" !important;
                font-style: normal !important;
                font-weight: normal !important;
                font-variant: normal !important;
                text-transform: none !important;
                speak: none;
                line-height: 1;
                -webkit-font-smoothing: antialiased;
            }
        }

        .toast-content {
            margin-left: .75rem;

            .vot-title {
                font-size: 1rem;
                line-height: 1.25;
                font-weight: 400;
            }

            .vot-body {
                font-weight: 300;
            }
        }
    }
</style>
